


















































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Button, Form, FormItem, Input } from 'element-ui';
import { vesselService } from '@/services/VesselService';

// components
import ModalCard from '@/components/layout/ModalCard.vue';

// mixins
import scrollError from '@/mixins/scrollError';

// rules
import rules from '@/rules/rules';

// types
import { VesselFields, VesselInput } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    ModalCard,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
/**
 * vessel    VesselFields for edition or null for creation
 * open      open status of the modal
 * isCreate  create or edit mode
 */
export default class VesselUpsert extends Mixins(scrollError) {
  @Prop({ required: false }) vessel!: VesselFields;
  @Prop({ default: false, type: Boolean }) open!: boolean;
  @Prop({ default: false, type: Boolean }) isCreate!: boolean;

  public $refs!: {
    vesselForm: HTMLFormElement;
  }

  private readonly rules = rules;

  private loading = false;
  private vesselInput = null;

  private close() {
    this.$emit('close');
  }

  private formatVesselInput(vessel?: VesselFields | null): VesselInput {
    return {
      imo: vessel?.imo || '',
      naccsCode: vessel?.naccsCode || '',
      name: vessel?.name || '',
      mmsi: vessel?.mmsi || ''
    };
  }

  private submit() {
    this.$refs.vesselForm.validate(async(valid: boolean) => {
      if (!valid) {
        this.scrollError(this.$refs.vesselForm);
        return;
      }

      this.loading = true;
      try {
        const response = await vesselService.upsertVessel(
          this.vesselInput,
          this.vessel?.id
        );

        if (response.data) {
          this.$emit('close');
          this.$emit('submit', (response.data as any).upsertVessel);
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.updated'),
            time: 2000
          });
          this.$refs.vesselForm.resetFields();
        }
      } catch (e) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      } finally {
        this.loading = false;
        this.$emit('close');
      }
    });
  }

  get searchLink() {
    const link = 'https://www.marinetraffic.com/en/ais/index/search/all';

    // if a name is present add name search to the link
    if (this.vesselInput?.name) {
      return link + `/keyword:${this.vesselInput?.name}/search_type:1`;
    }
    return link;
  }

  @Watch('open')
  private setInput() {
    this.vesselInput = this.formatVesselInput(this.vessel);
  }
}
